import Footer from '@/layouts/footer';
import Header from '@/layouts/header';
import type { AppLayoutProps } from '@/types';

export default ({ children }: AppLayoutProps) => (
    <>
        <div className="flex min-h-svh w-full flex-col py-safe px-safe">
            <Header />
            <main className="mx-auto flex h-full w-full max-w-7xl flex-1 animate-in flex-col justify-center gap-4 duration-600 fade-in py-2">
                {children}
            </main>
            <Footer />
        </div>
    </>
);
